import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IRestaurantsByIDsCustomersForFirmware } from 'types';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../../firmwareAssignmentState/firmwareAssignmentContext';
import { AssignImg } from 'components/AssignImg/AssignImg';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Restaurant.module.scss';

interface IRestaurant {
	data: IRestaurantsByIDsCustomersForFirmware[];
}

const Restaurant: React.FC<IRestaurant> = ({ data }) => {
	const { setIDsSelectedRestaurants, IDsSelectedRestaurants } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const handleChange = (isChecked: boolean, restaurantID: string) => {
		if (isChecked) {
			const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
			copyIDsSelectedRestaurants[restaurantID] = true;
			setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
		} else {
			const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
			delete copyIDsSelectedRestaurants[restaurantID];
			setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
		}
	};

	return (
		<div className={style.container} data-test="Restaurant">
			{data.map((el) => {
				const isChecked = el.restaurantId in IDsSelectedRestaurants;
				const isHaveFirmware = el.hasFirmwares;
				const itemClasses = classNames(style.item, {
					[style.assign]: isHaveFirmware,
					[style.isChecked]: isChecked,
				});

				return (
					<div className={itemClasses} key={el.restaurantId + 'mainDisplayRestaurantItem'}>
						<div className={style.imageWrapper}>
							{isHaveFirmware ? <AssignImg name="assignedFirmwareLabel" /> : null}
						</div>
						<div className={style.name}>
							<Checkbox
								className={style.checkbox}
								onChange={(e) => handleChange(e.target.checked, el.restaurantId)}
								checked={isChecked}
							/>
							<Text translationKey={el.address} withTooltip={true} />
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Restaurant;
